<router-outlet>
    <mat-spinner *ngIf="spinnerService.visibility.value" class="spinner" [diameter]="50"></mat-spinner>
</router-outlet>